import Vue from 'vue'
import store from 'store'
import { mapState, mapActions } from 'vuex'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { formatPrice } from 'utils/general'
import accessibility from 'mixins/accessibility'
import on from 'dom-event'

export default el => new Vue({
  el,
  store,
  data () {
    return {
      noteExpanded: false,
      message: ''
    }
  },
  mixins: [accessibility],
  mounted () {
    this.message = this.cart.note
    on(window, 'resize', () => this.calculateBodyHeight())
  },
  computed: {
    ...mapState('global', [
      'cart'
    ]),
    ...mapState('cart', [
      'open',
      'loading'
    ]),
    cartStatus () {
      return this.open
    },
    cartItems () {
      return (this.cart.items || [])
    },
    cartQuantity () {
      let qty = 0
      const items = this.cartItems.filter(item => __GLOBAL__.engravingItem.id !== item.id)
      for (let i = 0; i < items.length; i++) {
        qty = qty + items[i].quantity
      }
      // this.message = this.cart.note
      return qty
    },
    isEmpty () {
      return this.cartItems.length === 0
    },
    cartTotal () {
      return formatPrice(this.cart.total_price)
    },
    isActive () {
      return this.open
    }

  },
  methods: {
    ...mapActions('cart', [
      'toggleCart',
      'closeCart'
    ]),
    calculateBodyHeight () {
      if (!this.isEmpty) {
        const headerEl = document.querySelector('.js-header-cart-head-el').getBoundingClientRect().height
        const footerEl = document.querySelector('.js-header-cart-footer-el').getBoundingClientRect().height
        const bodyEl = document.querySelector('.js-header-cart-body-el')
        const totalWindowHeight = window.innerHeight
        const bodyHeight = totalWindowHeight - (headerEl + footerEl)

        if (bodyEl) {
          bodyEl.style.maxHeight = `${bodyHeight}px`
        }
      }
    },
    toggleBackgroundLock () {
      if (this.isActive) {
        this.calculateBodyHeight()

        disableBodyScroll(this.$refs.container)
      }
    },
    toggle () {
      this.toggleCart()
    },
    close () {
      this.closeCart()
      // const cartBodyWrapper = document.querySelector('body')
      // cartBodyWrapper.style.removeProperty('overflow')
      clearAllBodyScrollLocks('body')
      enableBodyScroll(this.$refs.container)
    },
    priceFormat (price) {
      return formatPrice(price)
    },
    toggleNote () {
      this.noteExpanded = !this.noteExpanded
    },
    checkoutCart () {
      this.$refs.cartForm.submit()
    }
  },
  watch: {
    open () {
      this.$nextTick(() => {
        this.toggleBackgroundLock()
      })
    }
  }
})
